import {infectionPathViewer} from './infection_path_viewer/infection_path_viewer';
import {jfAccordion} from './jf_accordion/jf_accordion';
import {jfCliView} from './jf_cli_view/jf_cli_view';
import {jfDetailsBar} from './jf_component_details_bar/jf_component_details_bar';
import {jfComponentTree} from './jf_component_tree/jf_component_tree';
import {jfCustomIssue} from './jf_custom_issue/jf_custom_issue';
import {jfCustomLicense} from './jf_custom_license/jf_custom_license';
//import {jfHeader} from './jf_header/jf_header';
//import {jfMessages} from './jf_messages/jf_messages';
//import {jfMessageContainer} from './jf_messages_container/jf_messages_container';
import {jfNetwork} from './jf_network/jf_network';
import {jfSeparator} from './jf_separator/jf_separator';
//import {jfSpinner} from './jf_spinner/jf_spinner';
import {jfSystemMonitor} from './jf_system_monitor/jf_system_monitor';
//import {jfTreeSearch} from './jf_tree_search/jf_tree_search';
import {jfUpdateStatus} from './jf_update_status/jf_update_status';
import {xrayJfValidatorName} from './validators/jf_validator_name';
import {jfValidatorPolicyName} from './validators/jf_validator_policy_name';
import {jfPolicyRule} from './jf_policy_rule/jf_policy_rule';
import {jfAboutBox} from './jf_about_box/jf_about_box';
import {jfPolicyRulesView} from './jf_policy_rules_view/jf_policy_rules_view';
import {jfRetryMessages} from './jf_retry_messages/jf_retry_messages';
/*
 import {jfSidebar} from "./jf_sidebar/jf_sidebar";
 */
angular.module('xray-ui.directives', ['xray-ui.services', 'xray-ui.dao', 'ui.select', 'ngSanitize', 'ui.highlight'])

    .directive({
        //'jfHeader': jfHeader,
        /*
         'jfSidebar': jfSidebar,
         */
        //'jfSpinner': jfSpinner,
        'infectionPathViewer': infectionPathViewer,
        'jfAccordion': jfAccordion,
        'jfNetwork': jfNetwork,
        'jfComponentTree': jfComponentTree,
        'jfSeparator': jfSeparator,
        'jfCustomIssue': jfCustomIssue,
        'jfCustomLicense': jfCustomLicense,
        //'jfTreeSearch': jfTreeSearch,
        //'jfMessages': jfMessages,
        'jfCliView': jfCliView,
        'jfUpdateStatus': jfUpdateStatus,
        'jfSystemMonitor': jfSystemMonitor,
        'jfDetailsBar': jfDetailsBar,
        'xrayJfValidatorName': xrayJfValidatorName,
        'jfValidatorPolicyName': jfValidatorPolicyName,
        //'jfMessageContainer': jfMessageContainer,
        'jfPolicyRule': jfPolicyRule,
        'jfAboutBox': jfAboutBox,
        'jfPolicyRulesView': jfPolicyRulesView,
        'jfRetryMessages': jfRetryMessages

    })
//        .service('ArtifactoryDeployModal', ArtifactoryDeployModal);



// WEBPACK FOOTER //
// ./modules/xray/directives/xray-ui.directives.module.js